
import { Suspense, lazy } from "react";
import "./Home.css";

// import jmk2025 from '../../assets/images/JMK Re 25.jpg';

// import jmkReport from '../../assets/images/jmk.jpeg';
// import crisilBridge from '../../assets/images/crisilBridge.webp';
// import gautamSolarRank from '../../assets/images/gautamSolarRank.webp';
// import New2 from "../../assets/images/new2.jpg"

import FAQ from "../../component/faq/FAQ";
import { Helmet } from "react-helmet";
import WhyChooseGautamSolar from "../../component/solarpanel/SolarPanel";
import AmongTopSolar from "../../component/amongtopsolar/AmongTopSolar";
import Kiwi from "../../component/Kiwi";
import Slider from "../../component/Slider/Slider";

// Lazy-loaded components
const VideoSecond = lazy(() => import("../../component/videosecond/VideoSecond"));

const SolarMod = lazy(() => import("../../component/solarmod/SolarMod"));
const Factories = lazy(() => import("../../component/factories/Factories"));
const SliderFirst = lazy(() => import("../../component/sliderfirst/SliderFirst"));
const ContactBox = lazy(() => import("../../component/enquiry/ContactBox"));



function Home() {
  
  const topSolar = [
    { title: ' JMK Research & Analytics', desc: 'RE Update FY 2025', img: '/TOP_10_JMK.webp', alt: 'Top 10 Solar ' },
    // { title: ' JMK Research & Analytics', desc: ' RE Update Q3 2025.', img: '/Top_8.webp', alt: 'Top 10 solar module' },
    { title: ' JMK Research & Analytics', desc: 'Among India Top 10 Solar Module Manufacturers', img: '/top10.jpeg', alt: 'Top 10 solar module' },
    // { title: ' JMK Research & Analytics', desc: ' RE Update Q4 2025.', img: '/JKM_Ranked.jpeg', alt: 'Top 10 solar module' },
    { title: ' CRISIL Bridge To India', desc: 'India PV Module Intelligence Brief | Q4 2024', img: '/Crisil.webp', alt: 'Top 10 solar ' },
    // { title: ' JMK 2024', desc: 'RE Update Q4 2024', img: '/JMK_Q4.webp', alt: 'Top 10 Solar ' },
  ]


  // const topSolar2 = [
  //   { img: '/Grade_A.webp' },
  //   { img: '/Global_Top_30.webp' },
  // ]

  const heading = "AMONG INDIA'S";
  const subHeading = "TOP 10 SOLAR MODULE MANUFACTURERS"

  return (
    <>
      <Helmet>
        <title>Top 10 Solar Module Manufacturers company in india</title>
        <meta
          name="description"
          content="Searching for the Best Top 10 Solar Module Manufacturers company in India? Gautam Solar is among the most reliable solar companies, boasting over 25 years of experience. The company specialises in producing high-efficiency solar modules, including Mono PERC and state-of-the-art N-Type TOPCon panels. "
        />
        <meta
          name="keywords"
          content="Top Solar Module Plant, Top 10 Solar Module Manufacturers company in india, India Solar Manufacturer company, Solar panels, solar manufacturing company in india"
        />
      </Helmet>
      <h1 className="sr-only">AMONG INDIA'S TOP 10 SOLAR MODULE MANUFACTURERS</h1>

      <Slider />

      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
            <div className="spinner-border" role="status" style={{ color: '#a20000' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      >
        <VideoSecond />
        <AmongTopSolar
          heading={heading}
          subHeading={subHeading}
          topSolar={topSolar} />
        <SolarMod />
        <Kiwi />
        <WhyChooseGautamSolar />
        <Factories />

        <SliderFirst />
        <FAQ />
        <ContactBox />
      </Suspense>
    </>
  );
}

export default Home;
